import type { MonthlyIncentiveGoal } from '../redux/vmsApi';

/**
 * Possible achievement statuses for a goal
 */
export type GoalAchievementStatus = 'achieved' | 'progress' | 'failed' | 'pending';

/**
 * Determines the achievement status of a goal based on actual vs target percentage
 * - achieved: actualPercentage >= 100% (or target)
 * - progress: actualPercentage between 80-99%
 * - failed: actualPercentage < 80%
 * - pending: no actualPercentage set
 */
export const getGoalAchievementStatus = (goal?: MonthlyIncentiveGoal): GoalAchievementStatus => {
  if (!goal?.actualPercentage && goal?.actualPercentage !== 0) {
    return 'pending';
  }
  
  const actual = goal.actualPercentage;
  const target = goal.targetPercentage ?? 100;
  
  if (actual >= target) {
    return 'achieved';
  } else if (actual >= 80) {
    return 'progress';
  } else {
    return 'failed';
  }
};

/**
 * Returns a color for the given goal status
 */
export const getGoalStatusColor = (status: GoalAchievementStatus): string => {
  switch (status) {
    case 'achieved':
      return '#4caf50'; // green
    case 'progress':
      return '#ff9800'; // orange
    case 'failed':
      return '#f44336'; // red
    case 'pending':
    default:
      return '#9e9e9e'; // grey
  }
};
